<template>
  <NuxtLayout><NuxtPage /></NuxtLayout>
</template>

<script setup lang="ts">
</script>

<style>
@import "./assets/css/main.css";
</style>
